import ApiService from "@/common/api.service";

export const GET_STOCK_PRODUCT_MOVEMENTS = "getStockProductMovements";

const state = {
  summary: null,
};

const getters = {
  stockProductMovementsSummary: (state) => state.summary,
};

const mutations = {
  SET_STOCK_PRODUCT_MOVEMENTS_SUMMARY(state, summary) {
    state.summary = summary;
  },
};

const actions = {
  [GET_STOCK_PRODUCT_MOVEMENTS](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.query("stock/product-movements", {
        ...(params || {}),
        ...context.rootGetters.stockContextFilterParams,
      })
        .then(({ data }) => {
          context.commit("SET_STOCK_PRODUCT_MOVEMENTS_SUMMARY", data.summary ?? null);
          resolve(data);
        })
        .catch(({ response }) => reject(response?.data));
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
